<!--  Map base controls -->

<div
  *ngIf="optionsCheck.controlliMappaAttivi"
  id="map-btn-group"
  class="btn-group-vertical"
  role="group"
  aria-label="Controlli generici"
>
  <button
    type="button"
    class="btn bg-blu txt-white"
    placement="left"
    ngbTooltip="Zoom In"
    (click)="incrementaZoom()"
  >
    <fa-icon [icon]="faPlus"></fa-icon>
  </button>

  <button
    type="button"
    class="btn bg-blu txt-white"
    placement="left"
    ngbTooltip="Zoom Out"
    (click)="diminuisciZoom()"
  >
    <fa-icon [icon]="faMinus"></fa-icon>
  </button>

  <button
    type="button"
    class="btn bg-blu txt-white"
    placement="left"
    ngbTooltip="Schermo Intero"
    (click)="schermoIntero()"
  >
    <fa-icon [icon]="faArrowsAlt"></fa-icon>
  </button>

  <button
    type="button"
    class="btn bg-blu txt-white"
    placement="left"
    ngbTooltip="Localizzami"
    (click)="localizza()"
    [ngClass]="{ active: localizzatoreId !== undefined }"
  >
    <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
  </button>

  <ng-template #tooltipStreetView>{{
    mapUtilsService.mappaGooglePronta
      ? "Street View"
      : "Per utilizzare questa funzione devi andare prima su Google Strade"
  }}</ng-template>
  <button
    *ngIf="isStreetViewBtnVisible"
    type="button"
    class="btn bg-blu txt-white"
    placement="left"
    [ngbTooltip]="tooltipStreetView"
    (click)="onHandleStreetView()"
    [ngClass]="{
      active: localizzatoreId !== undefined,
      disabled: !mapUtilsService.mappaGooglePronta
    }"
  >
    <fa-icon [icon]="faStreetView"></fa-icon>
  </button>

  <ng-template #tooltipTilt>
      {{
        mapUtilsService.mappaGooglePronta
          ? "Inclinazione " + currentTiltLabel + "°"
          : "Per utilizzare questa funzione devi andare prima su Google Satellite o Ibrido"
      }}
    </ng-template>

    <button
      type="button"
      class="btn bg-blu txt-white"
      (click)="onToggleTilt()"
      [disabled]="!mapUtilsService.mappaGooglePronta"
      [ngbTooltip]="tooltipTilt"
      placement="left"
    >
      <fa-icon [icon]="faRotate"></fa-icon>
    </button>
</div>

<!--  Map Advanced tools -->

<div class="ebw-text-right">
  
  <div class="mt-3">
    <button
      *ngIf="optionsCheck.drawingToolActive"
      type="button"
      class="btn bg-blu txt-white btnControl"
      placement="left"
      ngbTooltip="Tool Disegno"
      (click)="toolDisegno()"
      style="display: block"
    >
      <fa-icon [icon]="faDraftingCompass"></fa-icon>
    </button>
  </div>

  <!-- <div class="mt-3">
    <button type="button"
            class="btn bg-blu txt-white btnControl"
            placement="left"
            ngbTooltip="Tool Ricerca Geometrica"
            (click)="toolRicercaGeometrica()"
            style="display: block">
      <fa-icon [icon]="faDrawPolygon"></fa-icon>
    </button>
  </div> -->

  <div class="mt-3">
    <button
      *ngIf="optionsCheck.reprChoiceActive"
      type="button"
      class="btn bg-blu txt-white btnControl"
      placement="left"
      ngbTooltip="Scelta Rappresentazione"
      (click)="sceltaRappresentazione()"
      style="display: block"
    >
      <fa-icon [icon]="faLayerGroup"></fa-icon>
    </button>
  </div>

  <div class="mt-3">
    <button
      *ngIf="legendActive"
      type="button"
      class="btn bg-blu txt-white btnControl"
      placement="left"
      ngbTooltip="Legenda"
      (click)="legenda()"
      style="display: block"
    >
      <fa-icon [icon]="faMap"></fa-icon>
    </button>
  </div>
</div>
